import React, { useEffect, useRef, useState } from "react";

import { motion, useScroll, useTransform } from "framer-motion";

import { fadeScale, useWdInView } from "./WdMotion";



const previewSections = [

    { title: "Hero", width: "92%" },

    { title: "About", width: "78%" },

    { title: "Services", width: "85%" },

    { title: "Contact", width: "70%" },

];



export const WdStaticSection = () => {

    const { ref, inView } = useWdInView();

    const sectionRef = useRef<HTMLElement | null>(null);

    const { scrollYProgress } = useScroll({

        target: sectionRef,

        offset: ["start end", "end start"],

    });

    const orb1Y = useTransform(scrollYProgress, [0, 1], [0, -40]);

    const orb2Y = useTransform(scrollYProgress, [0, 1], [0, 30]);

    const [speed, setSpeed] = useState(0);

    const [visibleCount, setVisibleCount] = useState(0);



    useEffect(() => {

        if (!inView) {

            setSpeed(0);

            setVisibleCount(0);

            return;

        }



        let frame = 0;

        const speedAnim = setInterval(() => {

            frame += 2;

            setSpeed((s) => Math.min(100, s + 2));

            if (frame >= 50) clearInterval(speedAnim);

        }, 30);



        const seq = previewSections.map((_, i) =>

            setTimeout(() => setVisibleCount((c) => Math.max(c, i + 1)), 200 + i * 180)

        );



        return () => {

            clearInterval(speedAnim);

            seq.forEach(clearTimeout);

        };

    }, [inView]);



    return (

        <section className="wd-section wd-static" ref={(node) => {

            sectionRef.current = node;

            if (ref && "current" in ref) ref.current = node;

        }}>

            <motion.div className="wd-static__bg-orb wd-static__bg-orb--1" style={{ y: orb1Y }} />

            <motion.div className="wd-static__bg-orb wd-static__bg-orb--2" style={{ y: orb2Y }} />



            <div className="wd-container wd-static__grid">

                <div className="wd-static__copy">

                    <div className="wd-section-header">

                        <h2 className="wd-section-title">Static Website</h2>

                        <p className="wd-section-subtitle">

                            Fast, secure and{" "}

                            <span className="wd-accent">lightweight</span> web presence

                        </p>

                    </div>

                    <p className="wd-section-desc">

                        Fast, lightweight, and highly secure websites designed for businesses that

                        require a strong online presence with minimal maintenance. Perfect for

                        portfolios, company profiles, and landing pages.

                    </p>

                </div>



                <motion.div

                    className="wd-static__preview"

                    initial="hidden"

                    whileInView="visible"

                    viewport={{ once: false, amount: 0.2 }}

                    variants={fadeScale}

                >

                    <div className="wd-static__browser">

                        <div className="wd-static__browser-bar">

                            <span className="wd-dot wd-dot--red" />

                            <span className="wd-dot wd-dot--amber" />

                            <span className="wd-dot wd-dot--green" />

                            <div className="wd-static__url">yourbrand.com</div>

                        </div>

                        <div className="wd-static__browser-body">

                            {previewSections.map((sec, i) => (

                                <motion.div

                                    key={sec.title}

                                    className="wd-static__preview-block"

                                    initial={{ opacity: 0, scale: 0.96 }}

                                    animate={

                                        visibleCount > i

                                            ? { opacity: 1, scale: 1 }

                                            : { opacity: 0, scale: 0.96 }

                                    }

                                    transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}

                                >

                                    <span className="wd-static__preview-label">{sec.title}</span>

                                    <div

                                        className="wd-static__preview-line"

                                        style={{ width: sec.width }}

                                    />

                                </motion.div>

                            ))}

                        </div>

                    </div>



                    <div className="wd-static__meter">

                        <div className="wd-static__meter-label">

                            <span>Performance Score</span>

                            <strong>{speed}%</strong>

                        </div>

                        <div className="wd-static__meter-track">

                            <motion.div

                                className="wd-static__meter-fill"

                                animate={{ width: `${speed}%` }}

                                transition={{ duration: 0.3 }}

                            />

                        </div>

                        <div className="wd-static__meter-tags">

                            <span>Lightweight</span>

                            <span>Secure</span>

                            <span>SEO-ready</span>

                        </div>

                    </div>

                </motion.div>

            </div>

        </section>

    );

};


